import React from "react";
import { useAppData } from "../../../../common/hooks/useAppData";
import {
  SimpleForm,
  TextInput,
  SelectInput,
  FormDataConsumer,
  required,
  NumberInput,
} from "react-admin";
import { FormToolbar } from "../../../common/form/FormToolbar";
import { GenericDateOrTimePicker } from "../../../common/form/GenericDateOrTimePicker";
import { DatePicker, TimePicker } from "@material-ui/pickers";

interface Props {
  timeZone?: string | null;
}

export const DriverLogRemarkForm = ({ timeZone, ...props }: Props) => {
  const countriesAndStates = useAppData((x) => x.countries) ?? [];
  const countries = countriesAndStates.map((x) => ({ id: x.id, name: x.name }));
  return (
    <div className="form-create-edit-drawer">
      <SimpleForm variant="outlined" toolbar={<FormToolbar />} {...props}>
        <GenericDateOrTimePicker
          PickerComponent={DatePicker}
          source="date"
          timeZone={timeZone}
          disabled
        />
        <GenericDateOrTimePicker
          PickerComponent={TimePicker}
          timeZone={timeZone}
          source="time"
          options={{
            views: ["hours", "minutes", "seconds"],
          }}
          validate={[required()]}
        />
        <TextInput source="location" validate={[required()]} />
        <NumberInput source="odometer" validate={[required()]} />
        <SelectInput
          source="country"
          choices={countries}
          translate="no"
          validate={[required()]}
        />
        <FormDataConsumer>
          {({ scopedFormData, formData, getSource, ...rest }) => (
            <SelectInput
              source="state"
              translate="no"
              choices={
                countriesAndStates.find((x) => x.id === formData["country"])
                  ?.states ?? []
              }
              validate={[required()]}
              {...rest}
            />
          )}
        </FormDataConsumer>
        <TextInput source="remark" validate={required()} />
      </SimpleForm>
    </div>
  );
};
